import { render, staticRenderFns } from "./FixturesGameweek.vue?vue&type=template&id=04b0d5cd&scoped=true&"
import script from "./FixturesGameweek.vue?vue&type=script&lang=js&"
export * from "./FixturesGameweek.vue?vue&type=script&lang=js&"
import style0 from "./FixturesGameweek.vue?vue&type=style&index=0&id=04b0d5cd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b0d5cd",
  null
  
)

export default component.exports